import { forwardRef } from 'react';
import { FormattedMessage } from 'react-intl';

import { type MenuIntentProps } from '../../navigation/menu/Intent.js';
import { Menu } from '../../navigation/menu/Menu.js';

/**
 * Accepted properties for the IntentButton.OpenWith.
 * @public
 */
export type OpenWithProps = Omit<
  MenuIntentProps,
  'onResponse' | 'options' | 'children'
>;

/**
 * The `OpenWith` component renders an `IntentMenu` with a default label
 * that can't be changed.
 * @public
 */
export const OpenWith = /* @__PURE__ */ forwardRef<
  HTMLDivElement,
  OpenWithProps
>((props, forwardedRef) => {
  return (
    <Menu.Intent {...props} options={{ keyProperties: [] }} ref={forwardedRef}>
      <FormattedMessage
        id="F6H1FQ86mt53ZgVL"
        defaultMessage="Open with..."
        description="Default label for the intent button component."
      />
    </Menu.Intent>
  );
});

(OpenWith as typeof OpenWith & { displayName: string }).displayName =
  'IntentButton.OpenWith';
